import { render, staticRenderFns } from "./PlexItem.vue?vue&type=template&id=eb22dcf2&"
import script from "./PlexItem.vue?vue&type=script&lang=js&"
export * from "./PlexItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports